import { styled, css } from '@styledComponents';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { TextPairing } from '@components/TextPairing';
import { CloudImage } from '@components/CloudImage';
import { Columns, Column } from '@components/Columns';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const StyledTextPairing = styled(TextPairing)`
  display: flex;
  .text-pairing-body {
    font-family: AkkuratLLSub-LightSubset, sans-serif;
  }
  max-width: 512px;
  ${themeMediaQuery('xl')} {
    max-width: 605px;
  }
`;

export const StyledTextPairingMobile = styled(TextPairing)`
  ${themeMediaQuery('below_sm')} {
    display: flex;
  }
`;

export const StyledColumns = styled(Columns)`
  ${themeMediaQuery('sm')} {
    max-width: 100%;
    padding: 0;
    margin: 0;
  }
`;

export const StyledColumn = styled(Column)`
  padding: 0 0 0 4%;
`;

export const LeftColumn = styled(StyledColumn)`
  position: relative;
`;

const transition = css`
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
`;

export const BurstBox = styled(Box)`
  position: absolute;
  left: 0;
  ${transition};
  ${themeMediaQuery('sm')} {
    top: -10%;
  }
  ${themeMediaQuery('md')} {
    top: -25%;
  }
`;

export const LeftCloudImage = styled(CloudImage)`
  position: absolute;
  right: 0;
  top: 3%;
  border-radius: 4px;
`;

export const RightColumn = styled(StyledColumn)`
  position: relative;
  text-align: right;
`;

export const CurlBox = styled(Box)`
  position: absolute;
  left: -35%;
  top: -30%;
  ${transition};
  ${themeMediaQuery('sm')} {
    left: -75%;
  }
  ${themeMediaQuery('md')} {
    left: -50%;
  }
  @media (min-width: 1400px) {
    left: -35%;
  }
  ${themeMediaQuery('lg')} {
    left: -35%;
  }
  ${themeMediaQuery('xl')} {
    left: -20%;
  }
`;

export const CircleBox = styled(Box)`
  position: absolute;
  left: -10%;
  top: -22%;
  ${transition};
  ${themeMediaQuery('sm')} {
    left: -55%;
  }
  ${themeMediaQuery('md')} {
    left: -30%;
  }
  @media (min-width: 1400px) {
    left: -25%;
  }
  ${themeMediaQuery('lg')} {
    left: -25%;
  }
  ${themeMediaQuery('xl')} {
    left: -10%;
  }
`;

export const BlobBox = styled(Box)`
  position: absolute;
  right: 0;
  top: 0%;
  z-index: -1;
  img {
    width: 70%;
  }
  ${transition};
  ${themeMediaQuery('md')} {
    top: 35%;
  }
  @media (min-width: 1400px) {
    top: 20%;
  }
  ${themeMediaQuery('lg')} {
    top: 20%;
  }
  ${themeMediaQuery('xl')} {
    top: 0%;
  }
`;

export const BigThingsColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding-left: ${themeSpace(4)};
    padding-right: ${themeSpace(4)};
  }
`;

export const BigThingsColumn = styled(Column)`
  ${themeMediaQuery('below_sm')} {
    text-align: center;
    margin-top: ${themeSpace(13)};
    padding-top: ${themeSpace(15)};
    padding-bottom: ${themeSpace(10)};
    background: rgba(249, 245, 240, 0.7);
  }
`;

export const BigThingsAssetColumn = styled(Column)`
  text-align: right;
  padding-right: 5%;
  ${themeMediaQuery('below_sm')} {
    padding-right: 0.5rem;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -12%);
  }
`;

export const BigThingsCloudImage = styled(CloudImage)`
  width: 200px;
  height: 100%;
  border-radius: 50%;
  ${themeMediaQuery('below_sm')} {
    width: 220px;
    height: 100%;
  }
`;

export const BigThingsTitle = styled(Text)`
  ${themeMediaQuery('below_sm')} {
    width: 200px;
    margin: auto;
  }
`;

export const BigThingsBody = styled(Text)`
  ${themeMediaQuery('md')} {
    width: 395px;
  }
  ${themeMediaQuery('xl')} {
    width: 500px;
  }
`;
